
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"32","height":"33","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M16 3.738c7.07 0 12.8 5.73 12.8 12.8s-5.73 12.8-12.8 12.8-12.8-5.73-12.8-12.8 5.73-12.8 12.8-12.8z","fill":"url(#paint0_linear_6162_1326)"}}),_c('path',{attrs:{"d":"M9.072 13.157v5.074a2.077 2.077 0 002.084 2.066h7.397c.21 0 .38-.169.38-.374v-5.075a2.077 2.077 0 00-2.085-2.066H9.45c-.21 0-.38.17-.38.375zm10.331 1.98l3.054-2.231c.265-.22.47-.165.47.233v6.802c0 .452-.25.398-.47.233l-3.054-2.226v-2.812z","fill":"#fff"}}),_c('defs',[_c('linearGradient',{attrs:{"id":"paint0_linear_6162_1326","x1":"6.591","y1":"7.859","x2":"26.909","y2":"23.237","gradientUnits":"userSpaceOnUse"}},[_c('stop',{attrs:{"stop-color":"#4A8CFF"}}),_c('stop',{attrs:{"offset":"1","stop-color":"#23B7EC"}})])])])
          )
        }
      }
    